var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getSignInCaptchaSchema } from "../signIn/schema.signIn.utils";
import { EField } from "./schema.signInToken.types";
export var getSchema = function (initialValues) {
    return function (defaultValues) {
        var _a;
        var captcha = getSignInCaptchaSchema(initialValues, defaultValues);
        return {
            required: __spreadArray([EField.Token], captcha.required, true),
            properties: __assign((_a = {}, _a[EField.Token] = {
                default: getValue(EField.Token, initialValues, defaultValues),
            }, _a), captcha.properties),
        };
    };
};
export var uiSchema = function () {
    var _a;
    return (__assign((_a = { "rentio:trackingKey": "sign-in-token" }, _a[EField.Token] = {
        "ui:field": ERentioFormField.Text,
        title: getLocalizedText("auth.token.label"),
        placeholder: getLocalizedText("auth.token.label"),
    }, _a), getSignInCaptchaSchema({}, {}).uiSchema));
};
